import { Col, Divider, Form, Row, Select, Skeleton } from 'antd';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow_down.svg';
import { ReactComponent as CartIcon } from 'app/assets/img/icon_cart.svg';
import { ReactComponent as LocationIcon } from 'app/assets/img/icon_location_sub.svg';
import { ReactComponent as TimeIcon } from 'app/assets/img/icon_time_sub.svg';
import InputNumberContainer from 'app/components/InputNumberContainer';
import PartnerModal from 'app/components/PartnerModal';
import RenderIf from 'app/components/RenderIf';
import { StyledStack } from 'app/components/Stack';
import { StyledTag } from 'app/components/StyledTag';
import TicketDateSelectable from 'app/components/TicketDateSelectable';
import useTicketTimes from 'app/hooks/useGetUsedArea2';
import useWindowSize, { DESKTOP_WIDTH } from 'app/hooks/useWindowSize';
import { getPriceCartApi, getShowDetailApi } from 'app/services/showApi';
import format from 'date-fns/format';
import en from 'date-fns/locale/en-US';
import vi from 'date-fns/locale/vi';
import * as _ from 'lodash';
import moment from 'moment';
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-multi-carousel/lib/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { notify } from 'reapop';
import styled from 'styled-components';
import { BP_TYPE, DEFAULT_LANGUAGE, TICKET_TYPES } from 'utils/constants';
import { formatNumber, formatTimeFrame } from 'utils/helper';
import { useCommonSlice } from 'utils/hooks/useReduceCommon';
import { useSearchParams } from 'utils/hooks/useSearchParams';
import { useGlobalFunction } from '../App/hooks/useGlobalFunction';
import { selectInfoUser, selectIsLogged } from '../App/slice/selectors';
import { CART_ERROR_TYPE } from '../Cart/components/TicketItem';
import GrandstandDiagram from '../Cart/components/TicketItem/partials/components/GrandstandDiagram';
import { useCartNew } from '../Cart/hooks/useCartNew';
import { TDataTemp } from '../UnionRepresentative/types';
import TooltipParagraph from './tooltipParagraph';
import { safeNumber } from './components/helper';
import { useCheckCartConfig } from '../Checkout/hooks/useCheckCartConfig';
import { setOrderItems } from 'utils/orderRequestId';

export const QUANTITY_TAG = 2;
export const QUANTITY_PROMOTION = 2;
export enum PriceDisplayStatus {
  NA = 'NA',
  SHOW_BASE_PRICE = 'SHOW_BASE',
  SHOW_PRICE_ONLY = 'SHOW_PRICE_ONLY',
  SHOW_FROM_PRICE = 'SHOW_FROM',
}
registerLocale('vi', vi);
registerLocale('en', en);
setDefaultLocale(DEFAULT_LANGUAGE);
interface IParamPayLoad {
  date: string;
  show_id: number;
  zone_id?: number;
  restaurant_id?: number;
  previewB2b?: string;
  ticketType?: string;
}
export const FormItemTicket = (props: any) => {
  const {
    dataItem,
    startDate,
    endDate,
    translations,
    seeDetailShow,
    paymentMethodId,
    setIsShowDialogWarning,
    setMessageWarning,
    setLoadingPage,
    ticketFormId,
    newFilter,
    isLoading,
    allocatedDebt,
    partner,
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { getUrlParam } = useSearchParams();
  const selectZonePopupContainer = useRef<HTMLDivElement>(null);
  const selectPerformancePopupContainer = useRef<HTMLDivElement>(null);
  const selectRestaurantPopupContainer = useRef<HTMLDivElement>(null);
  const parkNameRef = useRef<HTMLDivElement>(null);
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const groupTicketDetailRef = useRef<HTMLDivElement>(null);
  const controlPrevValidAmountRef = useRef<{
    setPrevValidNumber: (value: number) => void;
  }>({ setPrevValidNumber: () => {} });
  const formTicketValues = useRef<Record<string, any>>({});

  const [groupTicketDetailDOMRect, setGroupTicketDetailDOMRect] =
    useState<DOMRect | null>(null);
  const [objectDate, setObjectDate] = useState<any>(null);
  const [newDataItem, setNewDataItem] = useState<any>(dataItem);
  const [arrayUsedArea, setArrayUsedArea] = useState<any>(null);
  const [disableMinus, setDisableMinus] = useState(true);
  const [loadingPrice, setLoadingPrice] = useState(false);
  const [jumpValue, setJumpValue] = useState(dataItem?.jumpValueB2b ?? 1);
  const [hasFetchedPrice, setHasFetchedPrice] = useState(false);
  const [openBpAllocatedModal, setOpenBpAllocatedModal] = useState(false);
  const [isValidSubmit, setIsValidSubmit] = useState(true);
  const [minAmount, setMinAmount] = useState(dataItem?.minAmountB2b || 1);
  const [ticketDateSelectableKey, setTicketDateSelectableKey] = useState(
    () =>
      `${moment(startDate).format('YYYY-MM-DD')}-${moment(endDate).format(
        'YYYY-MM-DD',
      )}`,
  );
  const [disableCreateOrder, setDisableCreateOrder] = useState(false);
  const [isCreatingOrderProxyBuyerFlow, setIsCreatingOrderBuyerFlow] =
    useState(false);

  const infoUser = useSelector(selectInfoUser);
  const isLogged = useSelector(selectIsLogged);
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const {
    device,
    windowSize: { width: screenWidth },
  } = useWindowSize();
  const { actions: commonActions } = useCommonSlice();
  const { onAddTicket, onGetCart } = useCartNew();
  const { checkConfig } = useCheckCartConfig();
  const preview = getUrlParam('previewB2b');
  const ticketTypeParam = getUrlParam('ticketType');
  const [form] = Form.useForm();
  const ticketAmount = Form.useWatch(`${dataItem.id}-amount`, form);
  const restaurantSelected = form.getFieldValue(`${dataItem?.id}-restaurant`);
  const zoneSelected = form.getFieldValue(`${dataItem?.id}-zone`);

  const isShowTag = useMemo(() => {
    const bp = partner ?? infoUser?.businessPartner;
    return !!bp?.bpLongTerm && !!bp?.allowBuyShortTerm;
  }, [partner, infoUser?.businessPartner]);

  const isProxyBuyer =
    infoUser?.businessPartner?.bpType === BP_TYPE.PROXY_BUYER;
  useEffect(() => {
    if (!dataItem?.id) return;
    setObjectDate(null);
    setArrayUsedArea(null);
    form.resetFields();
  }, [dataItem?.id]);
  useEffect(() => {
    if (newFilter || ticketTypeParam) {
      form.resetFields();
    }
  }, [newFilter, ticketTypeParam]);

  useEffect(() => {
    setNewDataItem(prev => ({ ...prev, isLongTerm: dataItem?.isLongTerm }));
  }, [dataItem?.isLongTerm]);

  useLayoutEffect(() => {
    const onSetGroupTicketDetailDOMRect = () => {
      if (!groupTicketDetailRef.current) return;
      setGroupTicketDetailDOMRect(
        groupTicketDetailRef.current.getBoundingClientRect(),
      );
    };
    onSetGroupTicketDetailDOMRect();
    window.addEventListener('resize', onSetGroupTicketDetailDOMRect);
    return () => {
      window.removeEventListener('resize', onSetGroupTicketDetailDOMRect);
    };
  }, []);

  const isTicketCable = useMemo(() => {
    return dataItem?.materialType === '9005';
  }, [dataItem?.materialType]);

  const hasRestaurants = useMemo(() => {
    return !_.isNil(dataItem?.restaurants) && !_.isEmpty(dataItem?.restaurants);
  }, [dataItem?.restaurants]);

  const getTicketTimeOptions = useMemo(
    () => ({
      payloadData: {
        date: form.getFieldValue(`${dataItem?.id}-date`),
        show_id: dataItem?.id,
        restaurant_id: form.getFieldValue(`${dataItem?.id}-restaurant`),
        zone_id: form.getFieldValue(`${dataItem?.id}-zone`),
      },
      applyZone: !isTicketCable,
      applyUsedZone2: !isTicketCable,
      isRestaurant: hasRestaurants,
      IIFE: false,
    }),
    [],
  );

  const { onFetchData } = useTicketTimes(getTicketTimeOptions);

  const onGoToDetailShow = (item: any) => {
    const startDateFormatted = format(startDate, 'yyyy-MM-dd');
    const endDateFormatted = format(endDate, 'yyyy-MM-dd');
    history.push(
      `/catalog/${item.id}?startDate=${startDateFormatted}&endDate=${endDateFormatted}&park=${item?.park?.id}`,
    );
  };

  const grandstandData = useMemo(() => {
    const restaurantByIdSelected = dataItem?.restaurants?.find(
      i => i?.id === restaurantSelected,
    );
    const zoneByIdSelected = dataItem?.zones?.find(i => i?.id === zoneSelected);
    if (!_.isEmpty(dataItem?.restaurants)) {
      return restaurantByIdSelected ?? dataItem?.restaurants?.[0];
    }
    if (!_.isEmpty(dataItem?.zones)) {
      return zoneByIdSelected ?? dataItem?.zones?.[0];
    }
    return undefined;
  }, [
    restaurantSelected,
    dataItem?.restaurants,
    zoneSelected,
    dataItem?.zones,
  ]);

  const getPrice = useCallback(
    async (
      params: {
        date: string;
        zone_id?: string;
        show_id: string;
        used_area2?: string;
        restaurant_id?: string;
        amount: string;
        ticketType?: string;
      },
      ticketData?: { jumpValue?: number; minAmount?: number },
      isNotRollBackAmount?: boolean,
      isLongTerm?: boolean,
      isCheckOut?: boolean,
    ) => {
      let isTryGetPrice = false;
      const ticketJump = ticketData?.jumpValue ?? jumpValue;
      const ticketAmount = ticketData?.minAmount ?? minAmount;
      if (!hasFetchedPrice) {
        setHasFetchedPrice(true);
      }

      try {
        if (!paymentMethodId) return;
        setIsValidSubmit(false);
        setLoadingPrice(true);
        const formData = new FormData();
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            formData.append(`items[0][${key}]`, value);
          }
        });
        formData.append('items[0][payment]', paymentMethodId);

        if (isLongTerm) {
          formData.append(`items[0][isLongTerm]`, '1');
        }

        if (isCheckOut) {
          formData.append(`checkLongTerm`, '1');
        }
        if (allocatedDebt !== null && allocatedDebt !== undefined)
          formData.append('items[0][bpAllocatedDebt]', allocatedDebt);
        const res = await getPriceCartApi(formData);
        if (
          res?.status === 200 &&
          _.isArray(res?.data) &&
          res?.data.length > 0
        ) {
          const dataInventory = res?.data[0];
          const maxAmountByJumpValue = isProxyBuyer
            ? Infinity
            : Math.floor(+dataInventory?.inventory / ticketJump) * ticketJump;
          if (
            maxAmountByJumpValue &&
            form.getFieldValue(`${dataItem.id}-amount`) >
              maxAmountByJumpValue &&
            !isNotRollBackAmount
          ) {
            isTryGetPrice = true;
            form.setFieldValue(`${dataItem.id}-amount`, maxAmountByJumpValue);
            controlPrevValidAmountRef.current.setPrevValidNumber(
              maxAmountByJumpValue,
            );
            return getPrice(
              {
                date: params.date,
                zone_id: params.zone_id,
                show_id: params.show_id,
                used_area2: params.used_area2,
                restaurant_id: params.restaurant_id,
                amount: maxAmountByJumpValue?.toString(),
              },
              undefined,
              undefined,
              isLongTerm,
              isCheckOut,
            );
          }
          form.setFieldsValue({
            [`${params.show_id}-price`]: +dataInventory.price,
          });
          form.setFields([{ name: `${params.show_id}-date`, errors: [] }]);
          const inventory = +(dataInventory?.inventory || 0);
          setNewDataItem(prev => ({
            ...prev,
            originalPrice: dataInventory.originalPrice,
            price: dataInventory.price,
            inventory: isProxyBuyer ? Infinity : inventory,
            isLongTerm: res?.data?.[0]?.isLongTerm ?? dataItem?.isLongTerm,
            ticketId: dataInventory?.id,
          }));
          let fieldName = `${params.show_id}-date`;
          let msg =
            dataInventory?.error?.message ||
            dataInventory?.errorTime ||
            dataInventory?.errorTicket ||
            '';
          if (
            [
              CART_ERROR_TYPE.JUMP_TICKET,
              CART_ERROR_TYPE.MIN_TICKET,
              CART_ERROR_TYPE.ERROR_TICKET,
            ].includes(res?.data?.[0]?.error?.errorType) ||
            (!!dataInventory?.errorTicket &&
              !dataInventory?.errorTime &&
              dataInventory?.error?.errorType !== CART_ERROR_TYPE.ERROR_TIME)
          ) {
            fieldName = `${dataItem.id}-amount`;
          }

          if (msg) {
            form.setFields([
              {
                name: fieldName,
                errors: [msg],
              },
            ]);
            setIsValidSubmit(false);
          } else {
            setIsValidSubmit(() => {
              if (isProxyBuyer) return true;
              return (
                inventory >= ticketAmount && +params.amount >= ticketAmount
              );
            });
          }
        }

        return res;
      } catch (error: any) {
        if (error?.action === 'popup') {
          onOpenDialogNoti({
            type: 'ERROR',
            isShow: true,
            title: '',
            content: error?.message,
            maskClosable: false,
            onCloseDialog() {
              setIsValidSubmit(true);
              onCloseDialogNoti();
            },
          });
          return;
        } else {
          form.setFields([
            { name: `${params.show_id}-date`, errors: [error?.message] },
          ]);
          setIsValidSubmit(false);
        }
      } finally {
        setLoadingPrice(isTryGetPrice);
      }
    },
    [dataItem, form, jumpValue, minAmount, paymentMethodId, allocatedDebt],
  );

  const getMinPrice = async (params: { date: string; show_id: number }) => {
    try {
      setIsValidSubmit(false);
      setLoadingPrice(true);
      const res = await getShowDetailApi({
        id: params.show_id,
        date: params.date,
        ticketType: sessionStorage.getItem('ticketType'),
      });

      if (res?.status === 200) {
        setNewDataItem(prev => ({
          ...prev,
          minPrice: res?.data?.minPrice,
        }));
      }
    } catch (error: any) {
      form.setFields([
        { name: `${params.show_id}-date`, errors: [error?.message] },
      ]);
    } finally {
      setLoadingPrice(false);
    }
  };

  const handleChangeUsedArea2 = useCallback(
    (used_area2, id) => {
      const zone = form.getFieldValue(`${id}-zone`);
      const date = form.getFieldValue(`${id}-date`);
      const restaurant = form.getFieldValue(`${id}-restaurant`);
      const amount = form.getFieldValue(`${id}-amount`);
      form.setFieldsValue({ [`${id}-used_area2`]: used_area2 });
      if (date) {
        getPrice({
          date: moment(date).format('YYYY-MM-DD'),
          zone_id: zone ?? '',
          show_id: id,
          used_area2,
          restaurant_id: restaurant ?? '',
          amount: amount,
        });
      }
    },
    [form, getPrice, paymentMethodId],
  );

  const callUsedArea = useCallback(() => {
    const zoneForm = form.getFieldValue(`${dataItem?.id}-zone`);
    const restaurantForm = form.getFieldValue(`${dataItem?.id}-restaurant`);
    const dateForm = form.getFieldValue(`${dataItem?.id}-date`);
    const usedArea2Form = form.getFieldValue(`${dataItem?.id}-used_area2`);
    if (!moment(dateForm, 'YYYY-MM-DD')?.isValid()) {
      setIsValidSubmit(false);
      return;
    }
    const paramPayLoad: IParamPayLoad = {
      date: dateForm,
      show_id: dataItem?.id,
      restaurant_id: restaurantForm,
      zone_id: zoneForm,
      ...(allocatedDebt ? { bpAllocatedDebt: allocatedDebt } : {}),
    };
    if (preview) {
      paramPayLoad.previewB2b = preview;
    }
    onFetchData({
      payloadData: paramPayLoad,
      callback: {
        onBefore: () => {
          setLoadingPage(true);
          return true;
        },
        onSuccess: resUsedArea => {
          setArrayUsedArea({
            [`${dataItem.id}-used_area2`]: resUsedArea.data.map(item => ({
              label: formatTimeFrame(item.label),
              value: item.value,
            })),
          });

          if (resUsedArea.data?.length === 1) {
            handleChangeUsedArea2(resUsedArea.data[0].value, dataItem.id);
          } else if (_.isEmpty(usedArea2Form)) {
            getMinPrice({
              date: paramPayLoad.date,
              show_id: paramPayLoad.show_id as number,
            });
          }
        },
        onError: error => {
          setArrayUsedArea({
            [`${dataItem.id}-used_area2`]: [],
          });
          console.log('onError', error);
        },
        onFinally: () => {
          setLoadingPage(false);
        },
      },
    });
  }, [dataItem.id, form, paymentMethodId, handleChangeUsedArea2]);

  const resetTimeout = amount => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      getPrice({
        date: form.getFieldValue(`${dataItem.id}-date`),
        zone_id: form.getFieldValue(`${dataItem.id}-zone`),
        show_id: dataItem.id,
        used_area2: form.getFieldValue(`${dataItem.id}-used_area2`),
        restaurant_id: form.getFieldValue(`${dataItem.id}-restaurant`),
        amount: amount,
      });
    }, 500);
  };

  const _handleChangeAmount = (
    value,
    validByJumpValue?: boolean,
    event?: 'change' | 'blur',
  ) => {
    setIsValidSubmit(false);
    const isError = value < minAmount;
    setDisableMinus(value <= minAmount);
    form.setFields([
      {
        name: `${dataItem.id}-amount`,
        value: +value <= 0 ? minAmount : value,
        errors: isError
          ? [
              translations?.['b2c.catalog-detail.min-amount'].replace(
                '${number}',
                minAmount,
              ),
            ]
          : [],
      },
    ]);
    // setIsValidSubmit(!isError && newDataItem?.inventory >= minAmount);
    event === 'blur' &&
      validByJumpValue &&
      !isError &&
      newDataItem?.inventory >= minAmount &&
      resetTimeout(value);
  };

  const isDisableSubmit = useMemo(() => {
    let _isDisable = !isValidSubmit;
    if (loadingPrice) {
      _isDisable = true;
    }
    return _isDisable;
  }, [isValidSubmit, loadingPrice]);

  const onChangeZone = (value: any, id: any) => {
    form.setFieldsValue({
      [`${id}-used_area2`]: null,
    });
    form.setFieldsValue({
      [`${id}-zone`]: value,
    });
    setArrayUsedArea({
      [`${id}-used_area2`]: [],
    });
    callUsedArea();
  };

  const onChangeRestaurant = (value: any, id: any) => {
    form.setFieldsValue({
      [`${id}-restaurant`]: value,
    });
    form.setFieldsValue({
      [`${id}-used_area2`]: null,
    });
    setArrayUsedArea({
      [`${id}-used_area2`]: [],
    });
    callUsedArea();
  };

  const handleChangeDate = useCallback(
    (value, id) => {
      setObjectDate({
        [`date-${id}`]: value,
      });
      setArrayUsedArea({
        [`${id}-used_area2`]: [],
      });
      form.setFields([
        {
          name: 'date',
          errors: [],
        },
        {
          name: `${dataItem.id}-amount`,
          value: minAmount,
          errors: [],
        },
        {
          name: `${id}-used_area2`,
          errors: [],
          value: null,
        },
        {
          name: `${id}-zone`,
          errors: [],
          value: null,
        },
        {
          name: `${id}-restaurant`,
          errors: [],
          value: null,
        },
      ]);
      if (moment(value)?.isValid()) {
        form.setFieldsValue({
          [`${id}-date`]: moment(value).format('YYYY-MM-DD'),
        });
        // setNewDataItem(dataItem);
        form.setFieldsValue({ [`${id}-used_area2`]: null });
        const amount = form.getFieldValue(`${id}-amount`);
        if (dataItem.materialType === '9005') {
          // park , slings
          getPrice({
            date: moment(value).format('YYYY-MM-DD'),
            show_id: id,
            amount: amount < minAmount ? minAmount : amount,
          });
        } else if (dataItem.zones?.length === 1 && value) {
          // check is only one zone
          form.setFieldsValue({
            [`${id}-zone`]: dataItem.zones[0].id,
          });
          callUsedArea();
        } else if (dataItem?.restaurants?.length === 1 && value) {
          // check is only one restaurant
          form.setFieldsValue({
            [`${id}-restaurant`]: dataItem.restaurants[0].id,
          });
          callUsedArea();
        } else if (
          _.isEmpty(dataItem?.zones) &&
          _.isEmpty(dataItem?.restaurants)
        ) {
          callUsedArea();
        } else if (
          _.isEmpty(form.getFieldValue(`${dataItem?.id}-used_area2`))
        ) {
          getMinPrice({
            date: form.getFieldValue(`${dataItem?.id}-date`),
            show_id: dataItem?.id,
          });
        }
      } else {
        form.setFieldsValue({
          [`${id}-date`]: '',
        });
        form.resetFields([]);
        setIsValidSubmit(false);
      }
      return true;
    },
    [dataItem?.id, paymentMethodId, allocatedDebt],
  );

  const convertDataOption = (arr, type) => {
    let result = [];
    if (arr?.length) {
      result = arr.map(item => ({
        ...item,
        value: item.id,
        label: ['zone', 'restaurants'].includes(type)
          ? item?.name
          : item?.timeFrom,
      }));
    }
    return result;
  };
  const normalizeValues = (values, dataItem, minAmount) => {
    const id = dataItem.id;
    const raw = {
      date: values[`${id}-date`],
      zone: values[`${id}-zone`],
      used_area2: values[`${id}-used_area2`],
      restaurant: values[`${id}-restaurant`],
      amount: Math.max(
        safeNumber(values[`${id}-amount`], minAmount),
        minAmount,
      ),
    };
    return Object.fromEntries(
      Object.entries(raw).filter(([_, v]) => v !== undefined && v !== null),
    );
  };

  const onFinishForm = async (values, dataItem, form) => {
    dispatch(commonActions.fetchLoadingPage());
    setIsValidSubmit(false);
    const normalized = normalizeValues(values, dataItem, minAmount);

    if (newDataItem?.inventory < minAmount) {
      form.setFields([
        {
          name: `${dataItem.id}-amount`,
          errors: [
            translations?.['b2c.catalog-detail.min-amount'].replace(
              '${number}',
              minAmount,
            ),
          ],
        },
      ]);
      setIsValidSubmit(false);
      dispatch(commonActions.fetchHiddenLoadingPage());

      return;
    }
    const callbackError = res => {
      const jumpValueErrHandler = () => {
        const errData = res?.data?.dataRequest?.[0];
        if (errData?.errorCode === 'jumpTicket') {
          setIsShowDialogWarning(true);
          setMessageWarning(errData?.message);
          form.setFieldsValue({
            [`${dataItem.id}-amount`]: errData?.minAmount,
          });
          getPrice(
            {
              date: form.getFieldValue(`${dataItem.id}-date`),
              zone_id: form.getFieldValue(`${dataItem.id}-zone`),
              show_id: dataItem.id,
              used_area2: form.getFieldValue(`${dataItem.id}-used_area2`),
              restaurant_id: form.getFieldValue(`${dataItem.id}-restaurant`),
              amount: errData?.minAmount,
            },
            { jumpValue: errData?.jumpTicket, minAmount: errData?.minAmount },
          );
        } else {
          // errorCode: minTicket
          form.setFields([
            {
              name: `${dataItem.id}-amount`,
              errors: [errData?.message],
            },
          ]);
        }
        setJumpValue(errData?.jumpTicket ?? 1);
        setMinAmount(errData?.minAmount);
        controlPrevValidAmountRef.current.setPrevValidNumber(
          errData?.minAmount ?? 1,
        );
        dispatch(commonActions.fetchHiddenLoadingPage());
      };

      let msg = '';
      let isPopup = false;
      let fieldName = `${dataItem.id}-date`;
      let response = res;
      if (
        [
          'Số vé hiện tại không đủ',
          'The current number of tickets is not enough',
        ].includes(msg) ||
        res?.data?.errorType === 'errorTicket'
      ) {
        fieldName = `${dataItem.id}-amount`;
        msg = res?.data?.message;
      }
      const isJumpValueError =
        res?.data?.dataRequest?.[0]?.errorCode === 'jumpTicket' ||
        res?.data?.dataRequest?.[0]?.errorCode === 'minTicket';
      if (isJumpValueError) return jumpValueErrHandler();
      // if (form.getFieldValue('type') === 'add') {
      //   response = res?.response;
      // }
      if (response?.status === 400) {
        msg = response?.data?.message;
      }
      if (res?.code === 400) {
        msg = response?.message;
      }
      if (
        [
          CART_ERROR_TYPE.JUMP_TICKET,
          CART_ERROR_TYPE.MIN_TICKET,
          CART_ERROR_TYPE.ERROR_TICKET,
        ].includes(res?.data?.[0]?.error?.errorType)
      ) {
        fieldName = `${dataItem.id}-amount`;
      } else if (res?.action === 'popup') {
        // create-order error
        setIsShowDialogWarning(true);
        setMessageWarning(msg);
        isPopup = true;
      }
      let _inventoryRes = isProxyBuyer ? Infinity : res?.data?.inventory;
      if (
        !_.isNumber(_inventoryRes) &&
        !_.isEmpty(res?.data?.dataInventory) &&
        _.isArray(res?.data?.dataInventory)
      ) {
        _inventoryRes = isProxyBuyer
          ? Infinity
          : res?.data?.dataInventory[0]?.inventory;
      }
      if (_.isNumber(_inventoryRes)) {
        setNewDataItem(prev => ({
          ...prev,
          inventory: _inventoryRes,
        }));
        !isProxyBuyer && _handleChangeAmount(_inventoryRes, dataItem.id);
        setIsValidSubmit(_inventoryRes >= minAmount);
      }
      !isPopup &&
        form.setFields([
          {
            name: fieldName,
            errors: msg ? [msg] : [],
          },
        ]);
      dispatch(commonActions.fetchHiddenLoadingPage());
    };
    const callBackSuccess = res => {
      if (!!infoUser) {
        onGetCart(isLogged, undefined, {
          ticketType: !!isShowTag ? `${ticketTypeParam}` : null,
          bpAllocatedDebt: allocatedDebt,
        });
      }
      dispatch(commonActions.fetchHiddenLoadingPage());

      // call api get cart
    };
    // add-to-card
    const typeSubmit = form.getFieldValue('type');
    if (typeSubmit === 'add') {
      onAddTicket?.(
        {
          show_id: dataItem?.id,
          amount: normalized?.amount ?? 1,
          used_area2: normalized?.used_area2,
          date: moment(normalized?.date).format('YYYY-MM-DD'),
          zone_id: normalized?.zone ?? '',
          payment: paymentMethodId,
          restaurant_id: normalized?.restaurant,
          bpAllocatedDebt: allocatedDebt ?? null,
        },
        callBackSuccess,
        callbackError,
      );
    }

    // create-order
    if (typeSubmit === 'buy') {
      dispatch(commonActions.fetchHiddenLoadingPage());

      setOrderItems([
        {
          ...dataItem,
          date: moment(normalized.date).format('YYYY-MM-DD'),
          price: newDataItem?.price,
          amount: normalized?.amount ?? 1,
          usedArea2: normalized?.used_area2,
          restaurant: dataItem?.restaurants.find(
            item => item?.id === normalized?.restaurant,
          ),
          allocatedDebt,
        },
      ]);

      const dataTemp: TDataTemp[] = [
        {
          show_id: dataItem.id,
          amount: normalized?.amount ?? 1,
          date: moment(normalized.date).format('YYYY-MM-DD'),
          used_area2: normalized?.used_area2,
          zone_id: normalized?.zone,
          payment: paymentMethodId,
          deliver_ticket_id: ticketFormId,
          restaurant_id: normalized?.restaurant,
          allocatedDebt,
          event: 1,
        },
      ];

      sessionStorage.setItem('dataTemp', JSON.stringify(dataTemp));
      history.push('/union-representative');
    }
    setIsValidSubmit(true);
  };

  const isComboTicket = useMemo(() => {
    return dataItem?.catalog?.mapVGS === 'S4';
  }, [dataItem?.catalog]);

  const isComboDiffTicket = useMemo(() => {
    return (
      dataItem?.catalog?.mapVGS === 'S4' &&
      dataItem?.park?.workstationId === 'DIF'
    );
  }, [dataItem?.catalog]);

  const initDateCallback = useCallback(
    value => {
      handleChangeDate(value, dataItem.id);
    },
    [dataItem.id, paymentMethodId],
  );

  useEffect(() => {
    if (!_.isInteger(paymentMethodId)) return;
    const id = dataItem.id;
    const date = form.getFieldValue(`${id}-date`);
    const usedArea2 = form.getFieldValue(`${id}-used_area2`);
    const checkIsCallGetPrice =
      date && (dataItem?.materialType === '9005' || usedArea2);
    if (!checkIsCallGetPrice) return;
    const amount = form.getFieldValue(`${id}-amount`);
    getPrice({
      date,
      zone_id: form.getFieldValue(`${id}-zone`),
      show_id: id,
      used_area2: usedArea2,
      restaurant_id: form.getFieldValue(`${id}-restaurant`),
      amount: amount,
    });
  }, [paymentMethodId]);
  const parkName = dataItem?.park?.name;

  useLayoutEffect(() => {
    if (!startDate || !endDate) return;
    setTicketDateSelectableKey(
      `${moment(startDate).format('YYYY-MM-DD')}-${moment(endDate).format(
        'YYYY-MM-DD',
      )}`,
    );
  }, [endDate, startDate]);

  const displayOriginalPriceFormat = useMemo(() => {
    const originalPrice = newDataItem?.originalPrice;
    const price = newDataItem?.price;
    const minPrice = newDataItem?.minPrice;
    const hasSelectedDate = !!objectDate?.[`date-${dataItem.id}`];
    let displayStatus: string = PriceDisplayStatus.NA;
    const handleChangeStaus = (
      disableCreateOrderValue: boolean,
      displayStatusValue: string,
    ) => {
      setDisableCreateOrder(disableCreateOrderValue);
      displayStatus = displayStatusValue;
    };
    (() => {
      if (!hasSelectedDate || (_.isNil(originalPrice) && hasFetchedPrice)) {
        // Không có ngày chọn hoặc không có giá cơ bản sau khi fetch → NA
        handleChangeStaus(true, PriceDisplayStatus.NA);
        return;
      }

      if (_.isNil(price)) {
        // Không có giá bán
        if (!_.isNil(minPrice)) {
          // Có minB → Hiển thị "Giá chỉ từ"
          handleChangeStaus(true, PriceDisplayStatus.SHOW_FROM_PRICE);
        } else {
          // Không có minB → NA
          handleChangeStaus(true, PriceDisplayStatus.NA);
        }
        return;
      }

      if (price === 0) {
        // Có CB và B = 0 → Hiển thị CB + B (bình thường) nhưng không mua được
        handleChangeStaus(true, PriceDisplayStatus.SHOW_BASE_PRICE);
        return;
      }

      if (originalPrice > price) {
        // CB > B → Hiển thị CB + B → mua được
        handleChangeStaus(false, PriceDisplayStatus.SHOW_BASE_PRICE);
        return;
      }

      if (originalPrice === 0 || originalPrice <= price) {
        // CB == B hoặc CB < B hoặc CB = 0 → chỉ hiển thị B → mua được
        handleChangeStaus(false, PriceDisplayStatus.SHOW_PRICE_ONLY);
        return;
      }

      // Trường hợp còn lại → NA
      handleChangeStaus(true, PriceDisplayStatus.NA);
    })();

    switch (displayStatus) {
      case PriceDisplayStatus.NA:
        return (
          <div className="--price" style={{ position: 'relative', top: 6 }}>
            <span className="--price-na">N/Ađ</span>
          </div>
        );

      case PriceDisplayStatus.SHOW_BASE_PRICE:
        return (
          <>
            <del className="--price-old">
              {formatNumber(originalPrice || 0)}đ
            </del>
            <div className="--price" style={{ position: 'static', top: 6 }}>
              {formatNumber(price || 0)}đ
            </div>
          </>
        );

      case PriceDisplayStatus.SHOW_PRICE_ONLY:
        return (
          <div className="--price" style={{ position: 'static', top: 6 }}>
            {formatNumber(price || 0)}đ
          </div>
        );

      case PriceDisplayStatus.SHOW_FROM_PRICE:
        return (
          <>
            <span className="--price-from-text">
              {translations
                ? translations['b2c.txt.price_only_from']
                : 'Giá chỉ từ'}
            </span>
            <div className="--price" style={{ position: 'static', top: 6 }}>
              {formatNumber(minPrice || 0)}đ
            </div>
          </>
        );

      default:
        return (
          <div className="--price" style={{ position: 'relative', top: 6 }}>
            <span className="--price-na">NAđ</span>
          </div>
        );
    }
  }, [newDataItem, objectDate, dataItem.id, translations]);

  const handleSubmitForm = async (values: any) => {
    const typeSubmit = form.getFieldValue('type');
    if (typeSubmit === 'buy') {
      const normalized = normalizeValues(values, dataItem, minAmount);
      const paramConfig = {
        ticket_id: newDataItem.ticketId,
        quantity: normalized.amount,
        date: normalized.date,
        ticketType: sessionStorage.getItem('ticketType') || '',
      };
      const resCheckConfig = await checkConfig([paramConfig], {
        onStart: () => {
          setIsValidSubmit(false);
          setLoadingPrice(true);
        },
        onFinish: () => {
          setLoadingPrice(false);
          setIsValidSubmit(true);
        },
        onError: (error, source) => {
          if (source === 'exception') return;
          const fieldName = `${dataItem.id}-date`;
          form.setFields([
            {
              name: fieldName,
              errors: error?.tickets ? [error?.tickets?.[0]?.message] : [],
            },
          ]);
        },
      });
      if (!resCheckConfig.ok) return;
    }
    if (typeSubmit === 'buy' && isProxyBuyer) {
      setOpenBpAllocatedModal(true);
      formTicketValues.current = values;
      return;
    }
    const amount = values[`${dataItem.id}-amount`] ?? minAmount;
    getPrice(
      {
        date: values[`${dataItem.id}-date`],
        amount: amount < minAmount ? minAmount : amount,
        show_id: dataItem.id,
        restaurant_id: values[`${dataItem.id}-restaurant`],
        used_area2: values[`${dataItem.id}-used_area2`],
        zone_id: values[`${dataItem.id}-zone`],
      },
      undefined,
      true,
      typeSubmit === 'buy' && newDataItem?.isLongTerm,
      typeSubmit === 'buy',
    ).then(res => {
      if (!!res?.data?.[0]?.error) {
        const jumpValueErrHandler = (res: any) => {
          const errData = res.data?.[0]?.error;
          if (errData?.errorCode === 'jumpTicket') {
            setIsShowDialogWarning(true);
            setMessageWarning(errData?.message);
            form.setFieldsValue({
              [`${dataItem.id}-amount`]: errData?.minAmount,
            });
            getPrice(
              {
                date: form.getFieldValue(`${dataItem.id}-date`),
                zone_id: form.getFieldValue(`${dataItem.id}-zone`),
                show_id: dataItem.id,
                used_area2: form.getFieldValue(`${dataItem.id}-used_area2`),
                restaurant_id: form.getFieldValue(`${dataItem.id}-restaurant`),
                amount: errData?.minAmount,
              },
              { jumpValue: errData?.jumpTicket, minAmount: errData?.minAmount },
              true,
            );
          } else {
            // errorCode: minTicket
            form.setFields([
              {
                name: `${dataItem.id}-amount`,
                errors: [errData?.message],
              },
            ]);
          }

          setJumpValue(errData?.jumpTicket ?? 1);
          setMinAmount(errData?.minAmount);
          controlPrevValidAmountRef.current.setPrevValidNumber(
            errData?.minAmount ?? 1,
          );
          dispatch(commonActions.fetchHiddenLoadingPage());
          return;
        };

        let msg = '';
        let isPopup = false;
        let fieldName = `${dataItem.id}-date`;
        let response = res?.data?.[0];
        const isJumpValueError =
          res?.data?.[0]?.error?.errorType === 'errorTicket' ||
          res?.data?.[0]?.error?.errorCode === 'jumpTicket' ||
          res?.data?.[0]?.error?.errorCode === 'minTicket';
        if (isJumpValueError) return jumpValueErrHandler(res);
        if (res?.data?.[0]?.error?.errorType === 'errorTime') {
          fieldName = `${dataItem.id}-date`;
          msg = res?.data?.[0]?.error?.message;
        }
        if (
          [
            'Số vé hiện tại không đủ',
            'The current number of tickets is not enough',
          ].includes(msg)
        ) {
          fieldName = `${dataItem.id}-amount`;
          msg = res?.data?.[0]?.error?.message;
        }
        let _inventoryRes = isProxyBuyer ? Infinity : response?.inventory;
        if (_.isNumber(_inventoryRes)) {
          setNewDataItem(prev => ({
            ...prev,
            inventory: _inventoryRes,
          }));
          _handleChangeAmount(_inventoryRes, dataItem.id);
          setIsValidSubmit(_inventoryRes >= minAmount);
        }
        !isPopup &&
          form.setFields([
            {
              name: fieldName,
              errors: msg ? [msg] : [],
            },
          ]);
        dispatch(commonActions.fetchHiddenLoadingPage());
        return;
      }

      if (res?.data?.[0]?.errorTicket) {
        form.setFields([
          {
            name: `${dataItem.id}-amount`,
            errors: [res?.data?.[0]?.errorTicket],
            value: Number(res?.data?.[0]?.inventory),
          },
        ]);
        return;
      } else {
        form.setFields([
          {
            name: `${dataItem.id}-amount`,
            errors: [],
          },
        ]);
      }

      if (!res) {
        return;
      }

      onFinishForm(values, dataItem, form);
    });
  };

  const handleBuyTicketProxyBuyerFlow = async (
    bpAllocatedDebt: string | number,
  ) => {
    const values = formTicketValues.current;

    setIsCreatingOrderBuyerFlow(true);

    const onGetPrice = async () => {
      try {
        const formData = new FormData();
        const amount = values[`${dataItem.id}-amount`] ?? minAmount;
        const getPricePayload = {
          date: values[`${dataItem.id}-date`],
          amount: amount,
          show_id: dataItem.id,
          restaurant_id: values[`${dataItem.id}-restaurant`],
          used_area2: values[`${dataItem.id}-used_area2`],
          zone_id: values[`${dataItem.id}-zone`],
        };
        Object.entries(getPricePayload).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            formData.append(`items[0][${key}]`, value);
          }
        });
        formData.append('items[0][payment]', paymentMethodId);
        if (newDataItem?.isLongTerm)
          formData.append(`items[0][isLongTerm]`, '1');
        formData.append(`checkLongTerm`, '1');
        formData.append(
          'items[0][bpAllocatedDebt]',
          bpAllocatedDebt?.toString(),
        );
        const res = await getPriceCartApi(formData);

        const dataInventory = res?.data?.[0];
        const isErrorSAP = !!(
          dataInventory?.error?.errorSap ?? dataInventory?.errorSap
        );
        const errMsg =
          dataInventory?.error?.message ??
          dataInventory?.errorTicket ??
          dataInventory?.errorTime;

        if (!errMsg) return res;

        if (!!isErrorSAP) {
          dispatch(
            notify(errMsg, 'error', {
              title: 'Oops',
              dismissAfter: 5000,
            }),
          );
          return false;
        }

        const errType = dataInventory?.error?.errorType;
        let fieldName = `${dataItem.id}-date`;
        if (
          [
            CART_ERROR_TYPE.JUMP_TICKET,
            CART_ERROR_TYPE.MIN_TICKET,
            CART_ERROR_TYPE.ERROR_TICKET,
          ].includes(errType)
        )
          fieldName = `${dataItem.id}-amount`;
        form.setFields([{ name: fieldName, errors: [errMsg] }]);
        setIsValidSubmit(false);

        //
        const errData = dataInventory?.error;
        const errCode = errData?.errorCode;
        if (errCode === CART_ERROR_TYPE.JUMP_TICKET) {
          setIsShowDialogWarning(true);
          setMessageWarning(errData?.message);
          form.setFieldsValue({
            [`${dataItem.id}-amount`]: errData?.minAmount,
          });
          getPrice(
            {
              date: form.getFieldValue(`${dataItem.id}-date`),
              zone_id: form.getFieldValue(`${dataItem.id}-zone`),
              show_id: dataItem.id,
              used_area2: form.getFieldValue(`${dataItem.id}-used_area2`),
              restaurant_id: form.getFieldValue(`${dataItem.id}-restaurant`),
              amount: errData?.minAmount,
            },
            {
              jumpValue: errData?.jumpTicket,
              minAmount: errData?.minAmount,
            },
            true,
          );
          setOpenBpAllocatedModal(false);
        } else {
          dispatch(
            notify(errMsg, 'error', {
              title: 'Oops',
              dismissAfter: 5000,
            }),
          );
        }
        setJumpValue(errData?.jumpTicket ?? 1);
        setMinAmount(errData?.minAmount);
        controlPrevValidAmountRef.current.setPrevValidNumber(
          errData?.minAmount ?? 1,
        );
        return false;
      } catch (error: any) {
        const errMsg = error?.message;
        dispatch(
          notify(errMsg, 'error', {
            title: 'Oops',
            dismissAfter: 5000,
          }),
        );
      }
    };

    const checkingData = await onGetPrice();

    if (!checkingData) {
      setIsCreatingOrderBuyerFlow(false);
      return;
    }

    const priceData = checkingData?.data?.[0];

    setOrderItems([
      {
        ...dataItem,
        date: moment(values[`${dataItem.id}-date`]).format('YYYY-MM-DD'),
        price: priceData?.price,
        amount: values[`${dataItem.id}-amount`] ?? 1,
        usedArea2: values[`${dataItem.id}-used_area2`],
        restaurant: dataItem?.restaurants.find(
          item => item?.id === values[`${dataItem.id}-restaurant`],
        ),
        allocatedDebt: bpAllocatedDebt,
      },
    ]);

    const dataTemp: TDataTemp[] = [
      {
        show_id: dataItem.id,
        amount: values[`${dataItem.id}-amount`] ?? 1,
        date: moment(values[`${dataItem.id}-date`]).format('YYYY-MM-DD'),
        used_area2: values[`${dataItem.id}-used_area2`],
        zone_id: values[`${dataItem.id}-zone`],
        payment: paymentMethodId,
        deliver_ticket_id: ticketFormId,
        restaurant_id: values[`${dataItem.id}-restaurant`],
        allocatedDebt: !!bpAllocatedDebt ? +bpAllocatedDebt : undefined,
        event: 1,
      },
    ];

    sessionStorage.setItem('dataTemp', JSON.stringify(dataTemp));
    history.push('/union-representative');

    setIsCreatingOrderBuyerFlow(false);
  };

  useEffect(() => {
    if (
      !allocatedDebt ||
      dataItem.materialType === TICKET_TYPES.CABLE_CAR ||
      (!form.getFieldValue(`${dataItem?.id}-zone`) &&
        !form.getFieldValue(`${dataItem?.id}-restaurant`)) ||
      !form.getFieldValue(`${dataItem.id}-date`)
    )
      return;

    setArrayUsedArea({
      [`${dataItem?.id}-used_area2`]: [],
    });

    form.setFields([
      {
        name: 'date',
        errors: [],
      },
      {
        name: `${dataItem?.id}-used_area2`,
        errors: [],
        value: null,
      },
      {
        name: `${dataItem?.id}-zone`,
        errors: [],
      },
      {
        name: `${dataItem?.id}-restaurant`,
        errors: [],
      },
    ]);
    callUsedArea();
  }, [
    dataItem.id,
    dataItem.materialType,
    dataItem?.restaurants?.length,
    dataItem.zones?.length,
    form,
    callUsedArea,
    allocatedDebt,
  ]);

  useEffect(() => {
    const date = form.getFieldValue(`${dataItem.id}-date`);

    if (!isTicketCable || !date || !allocatedDebt) return;

    getPrice({
      date: form.getFieldValue(`${dataItem.id}-date`),
      show_id: dataItem.id,
      amount: form.getFieldValue(`${dataItem.id}-amount`),
    });
  }, [allocatedDebt, dataItem.id, form, isTicketCable, getPrice]);

  const DEFAULT_IMAGE = '/static/img/Banner.png';
  return (
    <>
      <Col className="itemTicket">
        <div
          className="--group-img"
          style={{
            border: dataItem?.image?.original ? 'none' : '1px solid #d9d9d9',
          }}
        >
          <img
            src={dataItem?.image?.original || DEFAULT_IMAGE}
            alt=""
            width={310}
            loading="lazy"
            onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = DEFAULT_IMAGE;
            }}
          />
          {dataItem?.salePercentB2b ? (
            <div className="--discount-img">{`-${dataItem?.salePercentB2b}%`}</div>
          ) : undefined}
          <div className="--learn-more" onClick={() => seeDetailShow(dataItem)}>
            <div style={{ marginRight: 6 }}>
              {translations?.['b2c.txt.read-more']}
            </div>
            <i className="fa-solid fa-chevron-right"></i>
          </div>
        </div>
        <div className="group-detail-ticket" ref={groupTicketDetailRef}>
          <div className="d-flex justify-content-between align-items-center">
            <TooltipParagraph
              className="--title"
              onClick={() => onGoToDetailShow(dataItem)}
              style={{ marginBottom: 0 }}
            >
              {dataItem.name}
            </TooltipParagraph>
            {isShowTag && (
              <div
                style={{
                  marginTop: device !== 'desktop' ? '16px' : '6px',
                  padding: '4px 8px',
                  whiteSpace: 'nowrap',
                  background: '#F54949',
                  borderRadius: '8px',
                  color: 'white',
                  height: '25px',
                  fontSize: '12px',
                }}
              >
                {
                  translations?.[
                    `${
                      newDataItem?.isLongTerm
                        ? 'b2b.txt.long-term'
                        : 'b2b.txt.short-term'
                    }`
                  ]
                }
              </div>
            )}
          </div>

          <Row style={{ flexWrap: 'nowrap' }} gutter={24}>
            {parkName ? (
              <Col
                span={device !== 'mobile' && dataItem?.note ? 8 : 24}
                ref={parkNameRef}
                style={{
                  marginRight: 24,
                }}
              >
                <LocationIcon style={{ flexShrink: 0 }} />
                <div
                  style={{
                    display: 'inline-block',
                    width: 'calc(100% - 30px)',
                  }}
                >
                  <TooltipParagraph className="--description-name-park">
                    {dataItem?.park?.name}
                  </TooltipParagraph>
                </div>
              </Col>
            ) : null}
            {dataItem?.note ? (
              <Col span={device !== 'mobile' && parkName ? 15 : 24}>
                <TimeIcon style={{ flexShrink: 0 }} />
                <div
                  style={{
                    display: 'inline-block',
                    width: 'calc(100% - 30px)',
                  }}
                >
                  <TooltipParagraph className="--description-note" max={1}>
                    {dataItem?.note}
                  </TooltipParagraph>
                </div>
              </Col>
            ) : null}
          </Row>
          <div
            style={{
              marginTop: dataItem?.tagInfoResponse?.length ? '16px' : 0,
              marginBottom: 16,
            }}
          >
            {dataItem?.tagInfoResponse?.length ? (
              <StyledStack
                direction={'row'}
                style={{ flexWrap: 'wrap' }}
                rowGap={'6px'}
                columnGap={'6px'}
              >
                {dataItem?.tagInfoResponse
                  ?.slice(0, QUANTITY_TAG)
                  .map((itemTag, index) => (
                    <StyledTag
                      key={index}
                      title={
                        <div
                          style={{
                            gap: '5px',
                            color: itemTag?.textColor,
                          }}
                        >
                          {itemTag.content}
                        </div>
                      }
                      {...itemTag}
                      icon={itemTag?.icon?.original}
                    />
                  ))}
                {dataItem?.tagInfoResponse?.length > QUANTITY_TAG && (
                  <StyledTag
                    title={dataItem?.tagInfoResponse
                      ?.slice(QUANTITY_TAG)
                      .map(item => (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            gap: '8px',
                            color: item?.textColor,
                            marginBottom: '5px',
                          }}
                        >
                          <img
                            src={item?.icon?.original}
                            alt=""
                            height={'auto'}
                            width={14}
                          />
                          {item.content}
                        </div>
                      ))}
                    content={
                      <div style={{ fontWeight: 500 }}>
                        +{dataItem?.tagInfoResponse.length - QUANTITY_TAG}
                      </div>
                    }
                    textColor="#EC000B"
                    bgColor="#FFD6D6"
                  />
                )}
              </StyledStack>
            ) : null}
          </div>
          <div
            style={{
              marginTop: dataItem?.promotionInfoResponse?.length ? '16px' : 0,
              marginBottom: 16,
            }}
          >
            {dataItem?.promotionInfoResponse?.length ? (
              <StyledStack
                direction={'row'}
                style={{ flexWrap: 'wrap' }}
                rowGap={'6px'}
                columnGap={'6px'}
              >
                {dataItem?.promotionInfoResponse
                  ?.slice(0, QUANTITY_PROMOTION)
                  .map((itemPromotion, index) => (
                    <StyledTag
                      key={index}
                      title={
                        <div
                          style={{
                            gap: '5px',
                            color: itemPromotion?.textColor,
                          }}
                        >
                          {itemPromotion.content}
                        </div>
                      }
                      {...itemPromotion}
                      icon={itemPromotion?.icon?.original}
                    />
                  ))}
                {dataItem?.promotionInfoResponse?.length >
                  QUANTITY_PROMOTION && (
                  <StyledTag
                    title={dataItem?.promotionInfoResponse
                      ?.slice(QUANTITY_PROMOTION)
                      .map(item => (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            gap: '8px',
                            color: item?.textColor,
                            marginBottom: '5px',
                          }}
                        >
                          <img
                            src={item?.icon?.original}
                            alt=""
                            height={'auto'}
                            width={14}
                          />
                          {item.content}
                        </div>
                      ))}
                    content={
                      <div style={{ fontWeight: 500 }}>
                        +
                        {dataItem?.promotionInfoResponse.length -
                          QUANTITY_PROMOTION}
                      </div>
                    }
                    textColor="#EC000B"
                    bgColor="#FFD6D6"
                  />
                )}
              </StyledStack>
            ) : null}
          </div>
          <Form
            form={form}
            key={dataItem.id}
            onFinish={values => handleSubmitForm(values)}
          >
            <Row gutter={[32, 16]}>
              <Col span={device === 'desktop' ? 12 : 24} id="use-date-ticket">
                <Form.Item
                  className="custom-input"
                  label=""
                  name={`${dataItem.id}-date`}
                  rules={[
                    {
                      required: true,
                      message: translations
                        ? translations['b2c.txt.validateDate']
                        : '',
                    },
                  ]}
                  initialValue={
                    objectDate?.[`date-${dataItem.id}`]
                      ? moment(objectDate?.[`date-${dataItem.id}`])
                      : null
                  }
                  style={{ marginBottom: 0 }}
                >
                  <div className="d-flex align-items-center">
                    <div className="calender d-flex align-items-center col-md-6 col-sm-12">
                      <TicketDateSelectable
                        key={ticketDateSelectableKey}
                        isComboDiffTicket={isComboDiffTicket}
                        searchStartDate={moment(startDate)}
                        searchEndDate={moment(endDate)}
                        showDateFrom={dataItem.dateFrom}
                        showDateTo={dataItem.dateTo}
                        weekend={dataItem.weekend}
                        onChange={value => handleChangeDate(value, dataItem.id)}
                        onDefaultValue={initDateCallback}
                        disabled={loadingPrice}
                        value={moment(
                          form.getFieldValue(`${dataItem.id}-date`),
                        )}
                        fireworkDay={dataItem?.fireworkDay}
                      />
                    </div>
                  </div>
                </Form.Item>
              </Col>
              <Col
                span={device === 'desktop' ? 6 : 12}
                id="price-ticket"
                style={{ opacity: isProxyBuyer ? 0 : 1 }}
                // style={{ display: 'flex', alignItems: 'center' }}
              >
                {loadingPrice ? (
                  <Skeleton.Button
                    active
                    shape={'square'}
                    block
                    style={{ width: 100, opacity: 0.2 }}
                  />
                ) : (
                  <div>{displayOriginalPriceFormat}</div>
                )}
              </Col>
              <Col span={device === 'desktop' ? 6 : 12} id="amount-ticket">
                <Form.Item
                  className="custom-input ticket-count"
                  label=""
                  name={`${dataItem.id}-amount`}
                  initialValue={minAmount}
                  style={{ marginBottom: 0 }}
                >
                  <div
                    style={{
                      width: '100%',
                      display: device === 'desktop' ? 'block' : 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <div className="form-inputNumber">
                      <InputNumberContainer
                        value={ticketAmount || minAmount}
                        onChange={(value, validByJumpValue, event) =>
                          _handleChangeAmount(value, validByJumpValue, event)
                        }
                        min={1}
                        max={
                          minAmount > newDataItem?.inventory
                            ? minAmount
                            : newDataItem?.inventory
                        }
                        isLoading={isLoading}
                        isDisableMinus={disableMinus}
                        disabled={loadingPrice}
                        step={jumpValue}
                        onInvalidAmountByStep={() => {
                          setIsShowDialogWarning(true);
                          setMessageWarning(
                            translations?.['b2b.txt.onlyAmount']?.replace(
                              '${jumpValue}',
                              jumpValue,
                            ),
                          );
                        }}
                        lowerLimit={minAmount}
                        ref={controlPrevValidAmountRef}
                        isRunChangeEventWithSameValue
                        isSyncValuePropAndCompValueWhenTextValueEmpty
                      />
                    </div>
                  </div>
                </Form.Item>
              </Col>
              <RenderIf
                condition={
                  (!isTicketCable && !_.isEmpty(dataItem?.zones)) ||
                  (!isTicketCable && !_.isEmpty(dataItem?.restaurants)) ||
                  !isTicketCable
                }
                fallback={device === 'desktop' ? <Col span={12} /> : <></>}
              >
                <Col
                  span={device === 'desktop' ? 12 : 24}
                  className="box-feature-ticket"
                  id="ticket-zone"
                >
                  <Row style={{ width: 'calc(100% + 16px)' }} gutter={16}>
                    {!isTicketCable && !_.isEmpty(dataItem?.zones) && (
                      <Col span={12} className="--item-form">
                        <SelectPopupContainer
                          ref={selectZonePopupContainer}
                          popupMaxWidth={
                            !!groupTicketDetailDOMRect?.width
                              ? `${groupTicketDetailDOMRect?.width}px`
                              : undefined
                          }
                          popupWidth={
                            device === 'desktop'
                              ? 'initial'
                              : !!groupTicketDetailDOMRect?.width
                              ? `${groupTicketDetailDOMRect?.width}px`
                              : undefined
                          }
                        />
                        <Form.Item
                          className="custom-input"
                          label=""
                          name={`${dataItem.id}-zone`}
                          rules={[
                            {
                              required: true,
                              message: `${
                                translations?.['b2c.txt.plsChoose']
                              } ${
                                dataItem?.usedArea1Label?.toLowerCase() ?? ''
                              }`,
                            },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <StyledSelect
                            getPopupContainer={() =>
                              selectZonePopupContainer.current!
                            }
                            options={convertDataOption(dataItem?.zones, 'zone')}
                            dropdownRender={menu => (
                              <div className="custom-dropdown">{menu}</div>
                            )}
                            virtual={false}
                            placeholder={
                              dataItem?.usedArea1Label ||
                              translations?.['b2c.text.restaurants'] ||
                              ''
                            }
                            onChange={value => {
                              if (value) onChangeZone(value, dataItem.id);
                            }}
                            suffixIcon={<ArrowDownIcon />}
                            disabled={loadingPrice}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {!isTicketCable && !_.isEmpty(dataItem?.restaurants) && (
                      <Col span={12} className="--item-form" id="ticket-zone">
                        <SelectPopupContainer
                          ref={selectRestaurantPopupContainer}
                          popupMaxWidth={
                            !!groupTicketDetailDOMRect?.width
                              ? `${
                                  groupTicketDetailDOMRect?.width -
                                  (device === 'desktop' &&
                                  !isTicketCable &&
                                  !_.isEmpty(dataItem?.zones)
                                    ? 140
                                    : 0)
                                }px`
                              : undefined
                          }
                          popupWidth={
                            device === 'desktop'
                              ? 'initial'
                              : !!groupTicketDetailDOMRect?.width
                              ? `${groupTicketDetailDOMRect?.width}px`
                              : undefined
                          }
                        />
                        <Form.Item
                          className="custom-input"
                          label=""
                          name={`${dataItem.id}-restaurant`}
                          rules={[
                            {
                              required: true,
                              message: `${
                                translations?.['b2c.txt.plsChoose']
                              } ${
                                dataItem?.usedArea1Label?.toLowerCase() ?? ''
                              }`,
                            },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <StyledSelect
                            getPopupContainer={() =>
                              selectRestaurantPopupContainer.current!
                            }
                            options={convertDataOption(
                              dataItem?.restaurants,
                              'restaurants',
                            )}
                            dropdownRender={menu => (
                              <div className="custom-dropdown">{menu}</div>
                            )}
                            virtual={false}
                            placeholder={
                              dataItem?.usedArea1Label ||
                              translations?.['b2c.text.restaurants'] ||
                              ''
                            }
                            onChange={value => {
                              if (value) onChangeRestaurant(value, dataItem.id);
                            }}
                            suffixIcon={<ArrowDownIcon />}
                            disabled={loadingPrice}
                            placement={
                              device !== 'desktop' &&
                              !isTicketCable &&
                              !_.isEmpty(dataItem?.zones)
                                ? 'bottomRight'
                                : 'bottomLeft'
                            }
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {!isTicketCable && (
                      <Col
                        span={12}
                        className="--item-form"
                        id="ticket-performance"
                      >
                        <>
                          <SelectPopupContainer
                            ref={selectPerformancePopupContainer}
                            popupMaxWidth={
                              !!groupTicketDetailDOMRect?.width
                                ? `${groupTicketDetailDOMRect?.width}px`
                                : undefined
                            }
                            popupWidth={
                              device === 'desktop'
                                ? 'initial'
                                : !!groupTicketDetailDOMRect?.width
                                ? `${groupTicketDetailDOMRect?.width}px`
                                : undefined
                            }
                          />
                          <Form.Item
                            className="custom-input"
                            label=""
                            name={`${dataItem.id}-used_area2`}
                            rules={[
                              {
                                required: true,
                                message: `${
                                  translations?.['b2c.txt.plsChoose']
                                } ${
                                  dataItem?.usedArea2Label?.toLowerCase() ?? ''
                                }`,
                              },
                            ]}
                            style={{ marginBottom: 0 }}
                          >
                            <StyledSelect
                              getPopupContainer={() =>
                                selectPerformancePopupContainer.current!
                              }
                              options={
                                arrayUsedArea?.[`${dataItem.id}-used_area2`]
                              }
                              dropdownRender={menu => (
                                <div className="custom-dropdown">{menu}</div>
                              )}
                              virtual={false}
                              value={form.getFieldValue(
                                `${dataItem.id}-used_area2`,
                              )}
                              onChange={value =>
                                handleChangeUsedArea2(value, dataItem.id)
                              }
                              placeholder={
                                _.isEmpty(dataItem?.usedArea2Label)
                                  ? translations
                                    ? translations['b2c.txt.hours']
                                    : ''
                                  : dataItem?.usedArea2Label
                              }
                              suffixIcon={<ArrowDownIcon />}
                              disabled={
                                loadingPrice ||
                                (isComboTicket &&
                                  isComboDiffTicket &&
                                  (arrayUsedArea?.[`${dataItem.id}-used_area2`]
                                    ?.length ?? 0) === 0)
                              }
                              placement={
                                device !== 'desktop' &&
                                +_.isEmpty(dataItem?.restaurants) +
                                  +_.isEmpty(dataItem?.zones) ===
                                  1
                                  ? 'bottomRight'
                                  : 'bottomLeft'
                              }
                            />
                          </Form.Item>
                        </>
                      </Col>
                    )}
                  </Row>
                </Col>
              </RenderIf>
              <Col
                className="box-btn order-xs-last"
                id="ticket-submit"
                span={device === 'desktop' ? 12 : 24}
                style={{
                  display: 'flex',
                  transform: `translateX(${
                    screenWidth >= DESKTOP_WIDTH && screenWidth < 1280
                      ? '-28px'
                      : 0
                  })`,
                  justifyContent:
                    device === 'desktop' && screenWidth >= 1280
                      ? 'flex-end'
                      : 'flex-start',
                }}
              >
                <button
                  className="--btn-add-cart"
                  type="submit"
                  onClick={() => {
                    form.setFieldsValue({ type: 'add' });
                  }}
                  disabled={isDisableSubmit || disableCreateOrder}
                >
                  <CartIcon />
                  <div className="text-btn" style={{ width: 'max-content' }}>
                    {translations ? translations['b2c.text.add-cart'] : ''}
                  </div>
                </button>
                <button
                  type="submit"
                  className="--btn-buy-now"
                  onClick={() => {
                    form.setFieldsValue({ type: 'buy' });
                  }}
                  style={{
                    marginLeft: 8,
                    width: device === 'desktop' ? 'max-content' : '100%',
                    minWidth: 122,
                  }}
                  disabled={!isValidSubmit || disableCreateOrder}
                >
                  {translations ? translations['b2b.txt.create-order'] : ''}
                </button>
              </Col>
              <RenderIf condition={_.isNumber(newDataItem?.inventory)}>
                <>
                  <Col className="--item-form" id="ticket-grandstand" span={12}>
                    <GrandstandDiagram
                      grandstandData={grandstandData}
                      textCSS={{ marginTop: '0px' }}
                      displayDiagram={dataItem?.displayDiagram ?? ''}
                    />
                  </Col>
                  <Col
                    className="--item-form txt-ticket-count"
                    id="ticket-inventory"
                    span={12}
                    style={{ opacity: isProxyBuyer ? 0 : 1 }}
                  >
                    <span
                      className="txt-ticket-count"
                      style={{
                        color: '#808080',
                        fontWeight: 400,
                        textAlign: 'right',
                      }}
                    >
                      {`(${formatNumber(newDataItem?.inventory)} ${
                        translations?.['b2c.txt.in-stock']
                      })`}
                    </span>
                  </Col>
                </>
              </RenderIf>
            </Row>
          </Form>
        </div>
      </Col>
      <Divider
        style={{
          border: 'none',
          borderBottom: 'dashed 2px #d9d9d9',
          margin: '24px 0 34px',
        }}
      />
      <PartnerModal
        open={openBpAllocatedModal}
        onClose={() => setOpenBpAllocatedModal(false)}
        onChange={() => {}}
        onProceedToBookTicket={handleBuyTicketProxyBuyerFlow}
        loading={isCreatingOrderProxyBuyerFlow}
      />
    </>
  );
};

export const StyledSelect = styled(Select)`
  width: 133px;
  .ant-select-selection-placeholder {
    color: #808080;
  }
  &.ant-select-disabled {
    .ant-select-selector {
      background-color: #ffffff !important;
    }
  }
  &.ant-select {
    .ant-select-selector {
      border: none;
      border-bottom: solid 1px #ededed;
      border-radius: 0px;
      height: 40px;
      align-items: center;
      padding-left: 2px;
    }
    .ant-select-disabled {
      background: #ffffff;
    }
    &:hover {
      .ant-select-selector {
        border-color: #ededed;
      }
    }
  }
`;

export const SelectPopupContainer = styled.div<{
  popupMaxWidth?: string;
  popupWidth?: string;
}>`
  & > div:first-child {
    z-index: 1;
  }

  .ant-select-dropdown {
    width: ${props => props.popupWidth ?? 'initial'}!important;
    max-width: ${props => props.popupMaxWidth ?? 'initial'};
  }
`;
